import type { DashboardUnresolvedCommentDocument } from "@models";
import type { ReactNode } from "react";
import { DashboardConnectedCard } from "./DashboardConnectedCard";
import { DashboardUnresolvedCommentsList } from "./DashboardUnresolvedCommentsList";

type DashboardUnresolvedCommentsCardProps = {
  documents: DashboardUnresolvedCommentDocument[];
  count?: number;
  actions?: ReactNode;
  selectedDeviceId?: string;
  className?: string;
};

const getUnresolvedCommentsTotal = (
  documents: DashboardUnresolvedCommentDocument[]
) =>
  documents.reduce(
    (total, document) => total + document.unresolvedThreadIds.length,
    0
  );

export const DashboardUnresolvedCommentsCard = ({
  documents,
  count,
  actions,
  selectedDeviceId,
  className,
}: DashboardUnresolvedCommentsCardProps) => {
  return (
    <DashboardConnectedCard
      rootTestId="dashboard-unresolved-comments-connected-card"
      metricTestId="dashboard-unresolved-comments-metric-card"
      caption="Unresolved comments"
      totalNumber={count ?? getUnresolvedCommentsTotal(documents)}
      metricClassName="border-orange-200 bg-orange-50"
      valueClassName="text-orange-700"
      sectionLabel="Unresolved comments"
      actions={actions}
      className={className}
    >
      <div className="min-h-0 flex-1 overflow-y-auto pr-1">
        <DashboardUnresolvedCommentsList
          documents={documents}
          selectedDeviceId={selectedDeviceId}
        />
      </div>
    </DashboardConnectedCard>
  );
};
